module.exports = __webpack_public_path__ + "static/img/1.b295470.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-hogar/1.png
// module id = TRLs
// module chunks = 0